module.exports = __webpack_public_path__ + "img/qian_box_bg_zhTc.2e5c0bde.png";